import { defaultClient } from '@mint-sdk/api-core';

import { DataCheckUniquenessSchema } from '../shared/schemas/metadata.js';
import {
  CheckMetricUniquenessQuerySchema,
  ConversionMetricsResponseSchema,
  ConversionQuerySchema,
  CreateMetricRequestSchema,
  GoalMetricsOptionsQuerySchema,
  GoalMetricsOptionsResponseSchema,
  IntegrationQuerySchema,
  ListMetricsQuerySchema,
  MetricOptionResponseSchema,
  MetricOptionsQuerySchema,
  MetricsIntegrationsResponseSchema,
  OverrideMetricRequestSchema,
  OverrideMetricResponseSchema,
  ResponseDataMetricSchema,
  UpdateMetricRequestSchema,
} from '../shared/schemas/metrics.js';

export const getMetricIntegrationsQueryOptions = defaultClient.query({
  url: 'mdm/field-definition/metrics/integrations' as const,
  method: 'GET',
  responseSchema: MetricsIntegrationsResponseSchema,
  querySchema: IntegrationQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data.data;
  },
});

export const getMetricConversionsQueryOptions = defaultClient.query({
  url: 'mdm/field-definition/metrics/conversions' as const,
  method: 'GET',
  responseSchema: ConversionMetricsResponseSchema,
  querySchema: ConversionQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data.data;
  },
});

export const getMetricsListQuery = defaultClient.query({
  url: 'mdm/v2/metric/',
  method: 'GET',
  querySchema: ListMetricsQuerySchema,
  responseSchema: ResponseDataMetricSchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data.data;
  },
});

export const createMetricEndpoint = defaultClient.query({
  url: 'mdm/v2/metric/',
  method: 'POST',
  requestSchema: CreateMetricRequestSchema,
  responseSchema: ResponseDataMetricSchema,
});

export const updateMetricEndpoint = defaultClient.mutation({
  url: 'mdm/v2/metric/$metricId' as const,
  method: 'PUT',
  requestSchema: UpdateMetricRequestSchema,
  responseSchema: ResponseDataMetricSchema,
  processResponse: (data) => data,
});

export const overrideMetricEndpoint = defaultClient.mutation({
  url: 'mdm/v2/metric/overridden' as const,
  method: 'POST',
  requestSchema: OverrideMetricRequestSchema,
  responseSchema: OverrideMetricResponseSchema,
  processResponse: (data) => data,
});

export const getMetricsOptionsQuery = defaultClient.query({
  url: 'mdm/metric/options' as const,
  method: 'GET',
  responseSchema: MetricOptionResponseSchema,
  querySchema: MetricOptionsQuerySchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data.data;
  },
});

export const getGoalMetricsOptionsQuery = defaultClient.query({
  url: 'mdm/context_metadata/metrics/goals' as const,
  method: 'GET',
  responseSchema: GoalMetricsOptionsResponseSchema,
  querySchema: GoalMetricsOptionsQuerySchema,
  processResponse(data) {
    return data.data;
  },
  clientOptions: { request: { snakeCaseQueryParams: true } },
});

export const useCheckUniqueness = defaultClient.mutation({
  url: 'mdm/metric/check-uniqueness' as const,
  method: 'GET',
  querySchema: CheckMetricUniquenessQuerySchema,
  responseSchema: DataCheckUniquenessSchema,
  clientOptions: { request: { snakeCaseQueryParams: true } },
});
